import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './token-details-view.module.scss';
import { Button } from '../../../components';
import { handleCopy } from '../../../../../utils';

interface TokenDetailsViewProps {
  token: string;
  onClose: () => void;
  onDownloadReceipt: () => void;
  onViewTransaction: () => void;
  isDownloading?: boolean;
}

export const TokenDetailsView: React.FC<TokenDetailsViewProps> = ({
  token,
  onClose,
  onDownloadReceipt,
  onViewTransaction,
  isDownloading = false,
}) => {
  const { t } = useTranslation();
  const handleCopyToken = () => {
    handleCopy(token)
  };

  const CopyIcon =() => (<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2.8125C3 1.2592 4.2592 0 5.8125 0H10.6875C12.2408 0 13.5 1.2592 13.5 2.8125V7.695C13.5 9.24833 12.2408 10.5075 10.6875 10.5075H10.5V10.6875C10.5 12.2408 9.24082 13.5 7.6875 13.5H2.8125C1.2592 13.5 0 12.2408 0 10.6875V5.8125C0 4.2592 1.2592 3 2.8125 3H3V2.8125ZM10.5 9.3825V5.8125C10.5 4.2592 9.24082 3 7.6875 3H4.125V2.8125C4.125 1.88052 4.88052 1.125 5.8125 1.125H10.6875C11.6194 1.125 12.375 1.88052 12.375 2.8125V7.695C12.375 8.62695 11.6194 9.3825 10.6875 9.3825H10.5Z" fill="white" fill-opacity="0.8"/>
</svg>)


  return (
    <div className={styles.container}>
      {/* Success Icon */}
      <div className={styles.successIcon}>
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="24" fill="var(--app-landing-orange)" />
          <path
            d="M14 24L20 30L34 16"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Title and Subtitle */}
      <div className={styles.header}>
        <h1 className={styles.title}>{t('history.web.tokenDetails')}</h1>
        <p className={styles.subtitle}>{t('payment.transactionCompleteText')}</p>
      </div>

      {/* Token Card */}
      <div className={styles.tokenCard}>
        <div className={styles.tokenHeader}>
          <span className={styles.tokenLabel}>{t('buyElectricity.hereIsYourToken')}</span>
          <button className={styles.copyButton} onClick={handleCopyToken}>
            <CopyIcon/>
            <span>{t('common.actions.copy')}</span>
          </button>
        </div>
        <div className={styles.tokenValue}>
          {token}
        </div>
      </div>

      {/* Action Buttons */}
      <div className={styles.actionButtons}>
        <Button
          variant="primary"
          fullWidth
          onClick={onDownloadReceipt}
          disabled={isDownloading}
          className={styles.downloadButton}
        >
          {isDownloading ? t('history.web.downloading') : t('payment.downloadReceipt')}
        </Button>

        <Button
          variant="primary"
          fullWidth
          onClick={onViewTransaction}
          className={styles.viewTransactionButton}
        >
          {t('payment.viewTransaction')}
        </Button>
      </div>

      {/* Continue Button */}
      <div className={styles.continueSection}>
        <Button
          variant="primary"
          fullWidth
          onClick={onClose}
        //   className={styles.continueButton}
        >
          {t('common.actions.continueKey')}
        </Button>
      </div>
    </div>
  );
};